import * as React from 'react';
import { CircularProgressContainer, CircularProgressRotator } from './circular-progress.styles';

export const CircularProgress: React.FC<ICircularProgress> = props => {
    return (
        <CircularProgressContainer>
            <CircularProgressRotator size={props.size} color={props.color}>
                <svg viewBox="22 22 44 44">
                    <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6"></circle>
                </svg>
            </CircularProgressRotator>
        </CircularProgressContainer>
    );
};

interface ICircularProgress {
    readonly color?: string;
    readonly size?: number;
}
